import type { CSSProperties } from "react";
import { courseScrimColor } from "./courseScrim";
import { textColorsForBackground } from "./lessonCardColors";

type CohortCourseThumbProps = {
  readonly title: string;
  readonly heroImageUrl?: string | null;
  readonly accentColor?: string | null;
};

/** Compact course hero tile with title overlay (same top-left scrim rules as course details). */
export function CohortCourseThumb({ title, heroImageUrl, accentColor }: CohortCourseThumbProps) {
  const accent = accentColor?.trim() || null;
  const scrim = courseScrimColor(accentColor);
  const hasImage = Boolean(heroImageUrl);
  const titleColors = accent && !hasImage ? textColorsForBackground(accent) : null;

  return (
    <div
      className={[
        "cohort-course-thumb",
        hasImage ? "cohort-course-thumb--image" : null,
        accent ? "cohort-course-thumb--accent" : null,
      ]
        .filter(Boolean)
        .join(" ")}
      style={
        {
          "--cohort-thumb-scrim": scrim,
          ...(accent && !hasImage ? { "--cohort-thumb-bg": accent } : {}),
        } as CSSProperties
      }
      title={title}
    >
      {heroImageUrl ? (
        <img
          className="cohort-course-thumb-img"
          src={heroImageUrl}
          alt=""
          loading="lazy"
          crossOrigin="anonymous"
        />
      ) : null}
      {hasImage ? <div className="cohort-course-thumb-scrim" aria-hidden /> : null}
      <span
        className="cohort-course-thumb-title"
        style={titleColors ? { color: titleColors.title } : undefined}
      >
        {title}
      </span>
    </div>
  );
}
